import apiProxy from './api-proxy-inst';

class CommonApi {
  getCurrency(args) {
    return apiProxy.request('/currency/list', args).then(data => {
      return data;
    });
  }
}

export default new CommonApi();